import { shippingAddressFromUserAddress } from './addressUtils';
import { type RootState } from '../../redux/store';
import type SingleCheckoutTypes from '../singleCheckoutTypes';

const buildReviewRequest = (state: RootState): SingleCheckoutTypes.ReviewApiRequest => {
  const {
    cartSetKey,
    couponId,
    fflRequired,
    prizeId,
    selections,
    shipmentsNeedsAddress,
  } = state.singleCheckout;

  return {
    couponId,
    prizeId,
    key: cartSetKey,
    payment: selections.payment?.payment,
    shipping: {
      address:
        selections.shippingReady && !(selections.shippingAddress as SingleCheckoutTypes.SavedShippingAddress)?.id
          ? shippingAddressFromUserAddress(selections.shippingAddress as SingleCheckoutTypes.ShippingAddress)
          : undefined,
      addressId: selections.shippingReady
        ? (selections.shippingAddress as SingleCheckoutTypes.SavedShippingAddress)?.id
        : undefined,
      methods:
        shipmentsNeedsAddress
          ? undefined
          : selections.shippingMethods?.flatMap((method) => method.cartIds.map((cartId) => ({
            cartId,
            methodId: method.methodId,
          }))),
      primary: (selections.shippingAddress as SingleCheckoutTypes.SavedShippingAddress)?.primary || undefined,
      save: selections.shippingReady && !fflRequired
        && !(selections.shippingAddress as SingleCheckoutTypes.SavedShippingAddress)?.id,
    },
  };
};

export default buildReviewRequest;
